export const VIEWPORTS = {
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
};

export const GridConfig = {
  [VIEWPORTS.xl]: {
    columns: 12,
    gutter: 32,
  },
  [VIEWPORTS.lg]: {
    columns: 12,
    gutter: 32,
  },
  [VIEWPORTS.md]: {
    columns: 8,
    gutter: 32,
  },
  [VIEWPORTS.sm]: {
    columns: 6,
    gutter: 24,
  },
};

export const Breakpoints = {
  [VIEWPORTS.xl]: 1440,
  [VIEWPORTS.lg]: 1024,
  [VIEWPORTS.md]: 768,
  [VIEWPORTS.sm]: 375,
  [VIEWPORTS.xs]: 320,
};

export const Edges = {
  [VIEWPORTS.xl]: 64,
  [VIEWPORTS.lg]: 44,
  [VIEWPORTS.md]: 48,
  [VIEWPORTS.sm]: 24,
};

export const ContainersWidth = {
  [VIEWPORTS.xl]: `calc(100% - ${Edges[VIEWPORTS.xl] * 2}px)`,
  [VIEWPORTS.lg]: `calc(100% - ${Edges[VIEWPORTS.lg] * 2}px)`,
  [VIEWPORTS.md]: `calc(100% - ${Edges[VIEWPORTS.md] * 2}px)`,
  [VIEWPORTS.sm]: `calc(100% - ${Edges[VIEWPORTS.sm] * 2}px)`,
};

export const ColumnPadding = {
  [VIEWPORTS.xl]: GridConfig.xl.gutter / 2,
  [VIEWPORTS.lg]: GridConfig.lg.gutter / 2,
  [VIEWPORTS.md]: GridConfig.md.gutter / 2,
  [VIEWPORTS.sm]: GridConfig.sm.gutter / 2,
};

export const getNextBreakpoint = breakpoint => {
  let breakpointValues = [];
  for (const br in Breakpoints) {
    breakpointValues.push(Breakpoints[br]);
  }

  breakpointValues = breakpointValues.reverse();
  let nextBreakpoint = {};
  breakpointValues.forEach((value, i) => {
    if (value !== 1440) {
      nextBreakpoint[value] = breakpointValues[i + 1] - 1;
    } else {
      nextBreakpoint[value] = null;
    }
  });
  return nextBreakpoint[breakpoint];
};
